import React from "react";
import { Translate, withLocalize } from "react-localize-redux";
import DataTable from "../../../utils/components/DataTable";
import NavigationTabs from "../../../utils/components/NavigationTabs";
import { auth } from "../../../App/routes";
import { useNavigate } from "react-router";
import Loading from "../../../utils/components/Loading";
import timeStampToDateFormat from "../../../utils/helpers/timestampToDateFormat";

const columns = [
  {
    name: <Translate id="dashboard.uppercase_translates.task_id" />,
    selector: (row) => row.task_id,
    sortable: true,
    cell: (row) => (
      <div className="row-status" data-status={row.statusNo}>
        {row.task_id}
      </div>
    ),
  },
  {
    name: <Translate id="dashboard.uppercase_translates.form_name" />,
    selector: (row) => row.form.name,
    sortable: true,
  },
  {
    name: <Translate id="dashboard.uppercase_translates.form_no" />,
    selector: (row) => row.form.no,
    sortable: true,
    right: true,
  },
  {
    name: <Translate id="dashboard.uppercase_translates.status" />,
    selector: (row) => row.status,
    sortable: true,
    center: true,
    cell: (row) => <Translate id={`dashboard.${row.status}`} />,
  },

  {
    name: <Translate id="dashboard.uppercase_translates.assigned_to" />,
    selector: (row) => row.worker.name,
    sortable: true,
  },
  {
    name: <Translate id="dashboard.uppercase_translates.due_date" />,
    selector: (row) => row.due_date,
    format: (row) => timeStampToDateFormat(row.due_date, "dd.MM.yyyy"),
    sortable: true,
  },
];

const MyTasks = ({ tasks, project, translate, isLoading, noProjects }) => {
  const navigate = useNavigate();

  return (
    <div className="my-tasks page page-shadow">
      <div className="row">
        <div className="col">
          <NavigationTabs
            tabs={[translate("dashboard.my_tasks")]}
            activeTab={translate("dashboard.my_tasks")}
            onTabClick={() => {}}
            centerTabs
          />
        </div>
      </div>
      <div className="row">
        <div className="col d-flex">
          {project ? (
            <DataTable
              columns={columns}
              data={tasks}
              highlightOnHover
              onRowClicked={(row) => {
                navigate(
                  auth.taskDetails.link.replace(":id", row.task_id) +
                    `?locked=${row.locked}`
                );
              }}
              conditionalRowStyles={[
                {
                  when: (row) => row.statusNo === 1,
                  classNames: ["row-status", "row-status--incompleted"],
                },
                {
                  when: (row) => row.statusNo === 2,
                  classNames: ["row-status", "row-status--completed"],
                },
                {
                  when: (row) => row.statusNo === 3,
                  classNames: ["row-status", "row-status--pending"],
                },
              ]}
              noDataComponent={
                <p className="fw-bold text-center mt-3">
                  {translate("dashboard.no_task_related_to_project", {
                    project: project.name,
                  })}
                </p>
              }
              progressPending={isLoading}
              progressComponent={<Loading classNames="my-3" />}
            />
          ) : (
            <p className="fw-bold text-center">
              {translate(
                `dashboard.${
                  noProjects ? `no_projects` : `please_select_a_project`
                }`
              )}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default withLocalize(MyTasks);
